module.exports = __webpack_public_path__ + "img/BG000694959.45c4b847.svg";